<template>
    <section class="content-container logos pb-40 pr-40 pt-40 pl-40">
        <div class="close-section" @click="toggle">
            <span></span>
            <span></span>
        </div>
        <div v-if="page">
            <h2 class="mb-40 text-size-large text-uppercase content-title"
                :class="{ 'single-article-title text-size-big mw-720' : isArchiveBlog(this.$route) || isSingleBlog(this.$route) }">
                {{ this.title }}</h2>
            <time :datetime="page.date" class="d-block single-article-date mb-40"
                  v-if="isSingleBlog(this.$route) && page && page.date">
                {{ formatDate(page.date) }}
            </time>
            <div class="content contact-page" v-if="this.title === 'Contact'">
                <section-contact/>
            </div>
            <div class="content blog-posts" v-else-if="isArchiveBlog(this.$route)">
                <section-blog :posts="page"/>
            </div>
            <div class="content single-article" v-else-if="isSingleBlog(this.$route)">
                <section-post :post="page"/>
            </div>
            <div class="content" v-else>
                <div class="row" v-if="page.acf && page.acf.fields">
                    <div class="col-md-4" v-for="(single, key) in page.acf.fields" :key="key">
                        <img v-if="single.image" :src="single.image.url" :alt="single.image.alt">
                        <p class="info mb-40 mt-10">Client: <a v-if="single.link" :href="single.link"
                                                               target="_blank" rel="noopener noreferrer"><strong>{{
                                single.client
                            }}</strong></a><span
                            v-else><strong>{{ single.client }}</strong></span></p>
                    </div>
                </div>
            </div>
        </div>
        <p v-else>Loading...</p>
    </section>
</template>

<script>
import {nextTick} from "vue";
import {getPageBySlug, getPostBySlug, getPosts} from "@/services/api";
import {formatDate, isArchiveBlog, isSingleBlog, stripHTML} from "@/services/functions";
import router from "@/router";
import SectionContact from "@/components/section-contact.vue";
import {useHead} from '@vueuse/head';
import ogImage from "@/assets/images/fb.jpg";
import SectionBlog from "@/components/section-blog.vue";
import SectionPost from "@/components/section-post.vue";

export default {
    name: 'page-default',
    components: {SectionPost, SectionBlog, SectionContact},
    data() {
        return {
            page: null,
            title: '',
            titleHeight: 0
        };
    },
    created() {
        this.setDocumentState(true);
    },
    unmounted() {
        this.setDocumentState(false);
    },
    methods: {
        isSingleBlog,
        isArchiveBlog,
        formatDate,
        toggle() {
            router.push({path: '/'});
        },
        setDocumentState(isContentOpen = true) {
            const menu = document.querySelector('.nav-trigger');

            if (menu) {
                menu.style.display = isContentOpen ? 'none' : 'block';
            }

            document.documentElement.classList.toggle('menu-active', isContentOpen);
            document.documentElement.classList.toggle('content-active', isContentOpen);
        },
        setHeadTags() {
            const fallbackDescription = process.env.VUE_APP_SITE_DESCRIPTION;
            const excerpt = this.page?.excerpt?.rendered;
            const content = this.page?.content?.rendered;
            const descriptionSource = excerpt || content || fallbackDescription;
            const description = stripHTML(descriptionSource) || fallbackDescription;
            const ogImageLink = this.page?._embedded?.['wp:featuredmedia']?.[0]?.source_url ?? ogImage;
            const type = isSingleBlog(this.$route) ? 'article' : 'website';

            useHead({
                htmlAttrs: {
                    lang: 'en',
                },
                title: `${this.title} - ${process.env.VUE_APP_SITE_TITLE}`,
                meta: [
                    {name: 'description', content: description},
                    {property: 'og:title', content: `${this.title} - ${process.env.VUE_APP_SITE_TITLE}`},
                    {
                        property: 'og:site_name',
                        content: `${process.env.VUE_APP_SITE_TITLE} - ${process.env.VUE_APP_SITE_TAGLINE}`
                    },
                    {property: 'og:type', content: type},
                    {property: 'og:url', content: `${process.env.VUE_APP_SITE_URL}${this.$route.fullPath}`},
                    {property: 'og:description', content: description},
                    {property: 'og:image', content: ogImageLink},
                    {property: 'og:image:width', content: '1200'},
                    {property: 'og:image:height', content: '800'}
                ],
            });
        },
        async updateSinglePostLayout() {
            await nextTick();

            if (!isSingleBlog(this.$route)) {
                return;
            }

            const titleElement = document.querySelector('.content-container h2');
            const timeElement = document.querySelector('.content-container time');
            const contentSingleArticle = document.querySelector('.content.single-article');

            if (!titleElement || !timeElement || !contentSingleArticle) {
                return;
            }

            const titleHeight = titleElement.getBoundingClientRect().height;
            const timeHeight = timeElement.getBoundingClientRect().height;
            this.titleHeight = titleHeight + timeHeight + 130;
            contentSingleArticle.style.height = `calc(100vh - ${this.titleHeight}px)`;
        },
        async loadContent() {
            this.page = null;
            this.title = '';

            if (this.$route.name === 'blog') {
                this.page = await getPosts();
                this.title = 'Blog';
            } else if (this.$route.name === 'post') {
                this.page = await getPostBySlug(this.$route.params.slug);
                this.title = this.page?.title?.rendered ?? '';
            } else if (this.$route.name === 'page') {
                this.page = await getPageBySlug(this.$route.params.slug);
                this.title = this.page?.title?.rendered ?? '';
            }

            if (!this.page) {
                this.$router.replace({name: 'NotFound'});
                return;
            }

            this.setHeadTags();
            await this.updateSinglePostLayout();
        }
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            async handler() {
                await this.loadContent();
            },
        }
    },
};
</script>

<style scoped>
</style>
